import {
  KUNCHAN_VALUE_TO_LABEL_MAP,
  BOOK_PRICE_TOKYO_METRO_THIS_IS_MY_DREAM_LINE,
  BOOK_PRICE_TOKYO_METRO_THIS_IS_MY_DREAM_LINE_HARD_COVER,
  INPUT_NAME_KUN_CHAN,
  INPUT_VALUE_KUN_CHAN_NASHI,
  kunChanArr,
  BOOK_ALIAS_THIS_IS_MY_DREAM_LINE,
  childLikesTIMDLArr,
  CHILD_LIKES_TO_NAME_MAP,
} from '@shared/jp/product';
import {
  INPUT_NAME_KIDS_NAME,
  INPUT_VALUE_COVER_TYPE_HARD,
  INPUT_VALUE_COVER_TYPE_SOFT,
  INPUT_NAME_GENDER,
  INPUT_VALUE_GENDER_BOY,
  INPUT_VALUE_GENDER_GIRL,
  INPUT_NAME_HAIR_COLOR,
  INPUT_NAME_SKIN_COLOR,
  INPUT_VALUE_HAIR_COLOR_BLACK,
  INPUT_VALUE_HAIR_COLOR_BLONDE,
  INPUT_VALUE_HAIR_COLOR_BROWN,
  INPUT_VALUE_HAIR_COLOR_RED,
  INPUT_VALUE_SKIN_COLOR_WHITE,
  INPUT_VALUE_SKIN_COLOR_NUTMEG,
  INPUT_VALUE_SKIN_COLOR_BROWN,
  INPUT_VALUE_SKIN_COLOR_BLACK,
  INPUT_NAME_HAIR_STYLE,
  INPUT_VALUE_HAIR_STYLE_TIMDL_H01,
  INPUT_VALUE_HAIR_STYLE_TIMDL_H02,
  INPUT_VALUE_HAIR_STYLE_TIMDL_H03,
  INPUT_VALUE_HAIR_STYLE_TIMDL_H04,
  INPUT_VALUE_HAIR_STYLE_TIMDL_H05,
  INPUT_VALUE_HAIR_STYLE_TIMDL_H06,
  INPUT_VALUE_HAIR_STYLE_TIMDL_H07,
  INPUT_VALUE_HAIR_STYLE_TIMDL_H08,
  INPUT_VALUE_HAIR_STYLE_TIMDL_H09,
  INPUT_NAME_CLOTH_COLOR,
  INPUT_VALUE_CLOTH_COLOR_BLUE,
  INPUT_VALUE_CLOTH_COLOR_RED,
  INPUT_VALUE_CLOTH_COLOR_GREEN,
  INPUT_NAME_COVER_COLOR,
  INPUT_VALUE_COVER_COLOR_ORANGE,
  INPUT_VALUE_COVER_COLOR_PINK,
  INPUT_VALUE_COVER_COLOR_BLUE,
  INPUT_VALUE_COVER_COLOR_GREEN,
  INPUT_NAME_GLASSES,
} from '@shared/common/product';
import type {
  TGender,
  THairColor,
  TSkinColor,
  TCoverColor,
  TClothColor,
} from '@shared/common/product';
import type { ICanvasInputItem } from '@shared/common/data/inputs';
import {
  bookInputShowWhen,
  getRadioInputData,
  getRadioInputOptionData,
  getSelectInputData,
  getSelectInputOptionData,
  getTextInputData,
  bookInputsToNameValueMap,
  getCanvasInputData,
  INPUT_NAME_RESERVED_CANVAS1,
  getRadioIconInputData,
  getRadioIconInputOptionData,
  getRadioColorInputData,
  getRadioColorInputOptionData,
  getMultiselectInputData,
  getMultiselectInputOptionData,
  getCheckboxInputData,
} from '@shared/common/data/inputs';
import { getPriceData } from '@shared/jp/data/products';
import type { IBookPreview } from '@shared/jp/data/products';
import type { IReview } from '@shared/common/data/products';
import {
  EBannerTextColor,
  EDescriptionTextItemType,
  PURPOSE_ADVENTURE,
  PURPOSE_BIRTH_GIFT,
} from '@shared/common/data/products';
import {
  GET_BOOK_NAME_ERROR,
  getNameValidatorList,
} from '@shared/jp/data/inputs';
import type {
  THairStyleBoyTIMDL,
  THairStyleGirlTIMDL,
} from '@shared/jp/product';
import { getCoverHard, getCoverSoft } from './_utils';

/** ! TODO need exported by @studiobuki/shared  */
export const INPUT_NAME_CHILD_LIKES = 'childLikes' as const;

export const ThisIsMyDreamLineInputsKidsName = getTextInputData({
  label: '子どもの下の名前',
  placeholder: 'ひらがな６文字まで',
  name: INPUT_NAME_KIDS_NAME,
  validator: getNameValidatorList(6, 2),
  error: GET_BOOK_NAME_ERROR(6),
} as const);

export const ThisIsMyDreamLineInputsKunChan = getSelectInputData({
  label: 'くん・ちゃん付け',
  placeholder: '選んでください',
  options: kunChanArr.map((value) =>
    getSelectInputOptionData({
      label: KUNCHAN_VALUE_TO_LABEL_MAP[value],
      value,
    }),
  ),
  value: INPUT_VALUE_KUN_CHAN_NASHI,
  name: INPUT_NAME_KUN_CHAN,
} as const);

export const ThisIsMyDreamLineInputsGender = getRadioInputData({
  label: '性別',
  options: [
    getRadioInputOptionData({
      label: '男の子',
      value: INPUT_VALUE_GENDER_BOY,
    }),
    getRadioInputOptionData({
      label: '女の子',
      value: INPUT_VALUE_GENDER_GIRL,
    }),
  ],
  name: INPUT_NAME_GENDER,
});

export const ThisIsMyDreamLineInputsSkinColor = getRadioColorInputData({
  label: '肌の色',
  options: [
    getRadioColorInputOptionData({
      color: '#FFE0BD',
      value: INPUT_VALUE_SKIN_COLOR_WHITE,
    }),
    getRadioColorInputOptionData({
      color: '#FAD5A2',
      value: INPUT_VALUE_SKIN_COLOR_NUTMEG,
    }),
    getRadioColorInputOptionData({
      color: '#C68642',
      value: INPUT_VALUE_SKIN_COLOR_BROWN,
    }),
    getRadioColorInputOptionData({
      color: '#8D5524',
      value: INPUT_VALUE_SKIN_COLOR_BLACK,
    }),
  ],
  value: INPUT_VALUE_SKIN_COLOR_NUTMEG,
  name: INPUT_NAME_SKIN_COLOR as typeof INPUT_NAME_SKIN_COLOR,
});

export const ThisIsMyDreamLineInputsHairColor = getRadioColorInputData({
  label: 'かみ色',
  options: [
    getRadioColorInputOptionData({
      color: '#F8D992',
      value: INPUT_VALUE_HAIR_COLOR_BLONDE,
    }),
    getRadioColorInputOptionData({
      color: '#CF744B',
      value: INPUT_VALUE_HAIR_COLOR_RED,
    }),
    getRadioColorInputOptionData({
      color: '#9F6D48',
      value: INPUT_VALUE_HAIR_COLOR_BROWN,
    }),
    getRadioColorInputOptionData({
      color: '#4D423B',
      value: INPUT_VALUE_HAIR_COLOR_BLACK,
    }),
  ],
  value: INPUT_VALUE_HAIR_COLOR_BLACK,
  name: INPUT_NAME_HAIR_COLOR as typeof INPUT_NAME_HAIR_COLOR,
});

export const ThisIsMyDreamLineInputsClothColor = getRadioColorInputData({
  label: '服の色',
  options: [
    getRadioColorInputOptionData({
      color: '#5CB85C',
      value: INPUT_VALUE_CLOTH_COLOR_GREEN,
    }),
    getRadioColorInputOptionData({
      color: '#D9534F',
      value: INPUT_VALUE_CLOTH_COLOR_RED,
    }),
    getRadioColorInputOptionData({
      color: '#4A7FC1',
      value: INPUT_VALUE_CLOTH_COLOR_BLUE,
    }),
  ],
  value: INPUT_VALUE_CLOTH_COLOR_BLUE,
  name: INPUT_NAME_CLOTH_COLOR as typeof INPUT_NAME_CLOTH_COLOR,
});

export const COVER_COLOR_TO_NAME_MAP: Record<TCoverColor, string> = {
  [INPUT_VALUE_COVER_COLOR_ORANGE]: 'オレンジ',
  [INPUT_VALUE_COVER_COLOR_PINK]: 'ピンク',
  [INPUT_VALUE_COVER_COLOR_BLUE]: 'ブルー',
  [INPUT_VALUE_COVER_COLOR_GREEN]: 'グリーン',
};

export const ThisIsMyDreamLineInputsCoverColor = getRadioColorInputData({
  label: '表紙のベースの色を選びましょう',
  options: [
    getRadioColorInputOptionData({
      color: '#F37021',
      value: INPUT_VALUE_COVER_COLOR_ORANGE,
    }),
    getRadioColorInputOptionData({
      color: '#ED1A3B',
      value: INPUT_VALUE_COVER_COLOR_PINK,
    }),
    getRadioColorInputOptionData({
      color: '#00ABEA',
      value: INPUT_VALUE_COVER_COLOR_BLUE,
    }),
    getRadioColorInputOptionData({
      color: '#00AAAD',
      value: INPUT_VALUE_COVER_COLOR_GREEN,
    }),
  ],
  value: INPUT_VALUE_COVER_COLOR_ORANGE,
  name: INPUT_NAME_COVER_COLOR as typeof INPUT_NAME_COVER_COLOR,
});

export const ThisIsMyDreamLineInputsGlasses = getCheckboxInputData({
  label: 'メガネをかける',
  name: INPUT_NAME_GLASSES,
  value: false,
} as const);

export const ThisIsMyDreamLineInputsHairStyleBoy = getRadioIconInputData({
  label: 'かみ型',
  options: [
    getRadioIconInputOptionData({
      imgSrc: 'assets/images/timdl-hair-styles/very_short.png',
      value: INPUT_VALUE_HAIR_STYLE_TIMDL_H01,
    }),
    getRadioIconInputOptionData({
      imgSrc: 'assets/images/timdl-hair-styles/short.png',
      value: INPUT_VALUE_HAIR_STYLE_TIMDL_H02,
    }),
    getRadioIconInputOptionData({
      imgSrc: 'assets/images/timdl-hair-styles/mushroom.png',
      value: INPUT_VALUE_HAIR_STYLE_TIMDL_H03,
    }),
    getRadioIconInputOptionData({
      imgSrc: 'assets/images/timdl-hair-styles/long.png',
      value: INPUT_VALUE_HAIR_STYLE_TIMDL_H04,
    }),
    getRadioIconInputOptionData({
      imgSrc: 'assets/images/timdl-hair-styles/wavy.png',
      value: INPUT_VALUE_HAIR_STYLE_TIMDL_H05,
    }),
    getRadioIconInputOptionData({
      imgSrc: 'assets/images/timdl-hair-styles/curly.png',
      value: INPUT_VALUE_HAIR_STYLE_TIMDL_H06,
    }),
  ],
  value: INPUT_VALUE_HAIR_STYLE_TIMDL_H01,
  name: INPUT_NAME_HAIR_STYLE as typeof INPUT_NAME_HAIR_STYLE,
});

export const ThisIsMyDreamLineInputsHairStyleGirl = getRadioIconInputData({
  label: 'かみ型',
  options: [
    getRadioIconInputOptionData({
      imgSrc: 'assets/images/lmm-hair-styles/short_girl.png',
      value: INPUT_VALUE_HAIR_STYLE_TIMDL_H02,
    }),
    getRadioIconInputOptionData({
      imgSrc: 'assets/images/lmm-hair-styles/short_bob.png',
      value: INPUT_VALUE_HAIR_STYLE_TIMDL_H07,
    }),
    getRadioIconInputOptionData({
      imgSrc: 'assets/images/lmm-hair-styles/medium_bob.png',
      value: INPUT_VALUE_HAIR_STYLE_TIMDL_H08,
    }),
    getRadioIconInputOptionData({
      imgSrc: 'assets/images/lmm-hair-styles/long_with_bang.png',
      value: INPUT_VALUE_HAIR_STYLE_TIMDL_H04,
    }),
    getRadioIconInputOptionData({
      imgSrc: 'assets/images/lmm-hair-styles/pig_tail.png',
      value: INPUT_VALUE_HAIR_STYLE_TIMDL_H09,
    }),
    getRadioIconInputOptionData({
      imgSrc: 'assets/images/lmm-hair-styles/curly_girl.png',
      value: INPUT_VALUE_HAIR_STYLE_TIMDL_H06,
    }),
  ],
  value: INPUT_VALUE_HAIR_STYLE_TIMDL_H02,
  name: INPUT_NAME_HAIR_STYLE as typeof INPUT_NAME_HAIR_STYLE,
});

const ThisIsMyDreamLineInputsCanvasBoyInputs = [
  ThisIsMyDreamLineInputsSkinColor,
  ThisIsMyDreamLineInputsHairColor,
  ThisIsMyDreamLineInputsHairStyleBoy,
  ThisIsMyDreamLineInputsClothColor,
  ThisIsMyDreamLineInputsGlasses,
];

const ThisIsMyDreamLineInputsCanvasGirlInputs = [
  ThisIsMyDreamLineInputsSkinColor,
  ThisIsMyDreamLineInputsHairColor,
  ThisIsMyDreamLineInputsHairStyleGirl,
  ThisIsMyDreamLineInputsClothColor,
  ThisIsMyDreamLineInputsGlasses,
];

const ThisIsMyDreamLineItemsSkin: ICanvasInputItem[] = [
  {
    imgSrc: 'assets/images/timdl-canvas/M/avatar-M01.png',
    showWhen: [
      {
        inputToCheck: ThisIsMyDreamLineInputsSkinColor,
        condition: (v: TSkinColor) => v === INPUT_VALUE_SKIN_COLOR_WHITE,
      },
      {
        inputToCheck: ThisIsMyDreamLineInputsClothColor,
        condition: (v: TClothColor) => v === INPUT_VALUE_CLOTH_COLOR_GREEN,
      },
    ],
  },
  {
    imgSrc: 'assets/images/timdl-canvas/M/avatar-M02.png',
    showWhen: [
      {
        inputToCheck: ThisIsMyDreamLineInputsSkinColor,
        condition: (v: TSkinColor) => v === INPUT_VALUE_SKIN_COLOR_NUTMEG,
      },
      {
        inputToCheck: ThisIsMyDreamLineInputsClothColor,
        condition: (v: TClothColor) => v === INPUT_VALUE_CLOTH_COLOR_GREEN,
      },
    ],
  },
  {
    imgSrc: 'assets/images/timdl-canvas/M/avatar-M03.png',
    showWhen: [
      {
        inputToCheck: ThisIsMyDreamLineInputsSkinColor,
        condition: (v: TSkinColor) => v === INPUT_VALUE_SKIN_COLOR_BROWN,
      },
      {
        inputToCheck: ThisIsMyDreamLineInputsClothColor,
        condition: (v: TClothColor) => v === INPUT_VALUE_CLOTH_COLOR_GREEN,
      },
    ],
  },
  {
    imgSrc: 'assets/images/timdl-canvas/M/avatar-M04.png',
    showWhen: [
      {
        inputToCheck: ThisIsMyDreamLineInputsSkinColor,
        condition: (v: TSkinColor) => v === INPUT_VALUE_SKIN_COLOR_BLACK,
      },
      {
        inputToCheck: ThisIsMyDreamLineInputsClothColor,
        condition: (v: TClothColor) => v === INPUT_VALUE_CLOTH_COLOR_GREEN,
      },
    ],
  },
  {
    imgSrc: 'assets/images/timdl-canvas/M/avatar-M05.png',
    showWhen: [
      {
        inputToCheck: ThisIsMyDreamLineInputsSkinColor,
        condition: (v: TSkinColor) => v === INPUT_VALUE_SKIN_COLOR_WHITE,
      },
      {
        inputToCheck: ThisIsMyDreamLineInputsClothColor,
        condition: (v: TClothColor) => v === INPUT_VALUE_CLOTH_COLOR_RED,
      },
    ],
  },
  {
    imgSrc: 'assets/images/timdl-canvas/M/avatar-M06.png',
    showWhen: [
      {
        inputToCheck: ThisIsMyDreamLineInputsSkinColor,
        condition: (v: TSkinColor) => v === INPUT_VALUE_SKIN_COLOR_NUTMEG,
      },
      {
        inputToCheck: ThisIsMyDreamLineInputsClothColor,
        condition: (v: TClothColor) => v === INPUT_VALUE_CLOTH_COLOR_RED,
      },
    ],
  },
  {
    imgSrc: 'assets/images/timdl-canvas/M/avatar-M07.png',
    showWhen: [
      {
        inputToCheck: ThisIsMyDreamLineInputsSkinColor,
        condition: (v: TSkinColor) => v === INPUT_VALUE_SKIN_COLOR_BROWN,
      },
      {
        inputToCheck: ThisIsMyDreamLineInputsClothColor,
        condition: (v: TClothColor) => v === INPUT_VALUE_CLOTH_COLOR_RED,
      },
    ],
  },
  {
    imgSrc: 'assets/images/timdl-canvas/M/avatar-M08.png',
    showWhen: [
      {
        inputToCheck: ThisIsMyDreamLineInputsSkinColor,
        condition: (v: TSkinColor) => v === INPUT_VALUE_SKIN_COLOR_BLACK,
      },
      {
        inputToCheck: ThisIsMyDreamLineInputsClothColor,
        condition: (v: TClothColor) => v === INPUT_VALUE_CLOTH_COLOR_RED,
      },
    ],
  },
  {
    imgSrc: 'assets/images/timdl-canvas/M/avatar-M09.png',
    showWhen: [
      {
        inputToCheck: ThisIsMyDreamLineInputsSkinColor,
        condition: (v: TSkinColor) => v === INPUT_VALUE_SKIN_COLOR_WHITE,
      },
      {
        inputToCheck: ThisIsMyDreamLineInputsClothColor,
        condition: (v: TClothColor) => v === INPUT_VALUE_CLOTH_COLOR_BLUE,
      },
    ],
  },
  {
    imgSrc: 'assets/images/timdl-canvas/M/avatar-M10.png',
    showWhen: [
      {
        inputToCheck: ThisIsMyDreamLineInputsSkinColor,
        condition: (v: TSkinColor) => v === INPUT_VALUE_SKIN_COLOR_NUTMEG,
      },
      {
        inputToCheck: ThisIsMyDreamLineInputsClothColor,
        condition: (v: TClothColor) => v === INPUT_VALUE_CLOTH_COLOR_BLUE,
      },
    ],
  },
  {
    imgSrc: 'assets/images/timdl-canvas/M/avatar-M11.png',
    showWhen: [
      {
        inputToCheck: ThisIsMyDreamLineInputsSkinColor,
        condition: (v: TSkinColor) => v === INPUT_VALUE_SKIN_COLOR_BROWN,
      },
      {
        inputToCheck: ThisIsMyDreamLineInputsClothColor,
        condition: (v: TClothColor) => v === INPUT_VALUE_CLOTH_COLOR_BLUE,
      },
    ],
  },
  {
    imgSrc: 'assets/images/timdl-canvas/M/avatar-M12.png',
    showWhen: [
      {
        inputToCheck: ThisIsMyDreamLineInputsSkinColor,
        condition: (v: TSkinColor) => v === INPUT_VALUE_SKIN_COLOR_BLACK,
      },
      {
        inputToCheck: ThisIsMyDreamLineInputsClothColor,
        condition: (v: TClothColor) => v === INPUT_VALUE_CLOTH_COLOR_BLUE,
      },
    ],
  },
];

const ThisIsMyDreamLineItemsHairBoy: ICanvasInputItem[] = [
  {
    imgSrc: 'assets/images/timdl-canvas/H/avatar-H01.png',
    showWhen: [
      {
        inputToCheck: ThisIsMyDreamLineInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BLONDE,
      },
      {
        inputToCheck: ThisIsMyDreamLineInputsHairStyleBoy,
        condition: (v: THairStyleBoyTIMDL) =>
          v === INPUT_VALUE_HAIR_STYLE_TIMDL_H01,
      },
    ],
  },
  {
    imgSrc: 'assets/images/timdl-canvas/H/avatar-H02.png',
    showWhen: [
      {
        inputToCheck: ThisIsMyDreamLineInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BLONDE,
      },
      {
        inputToCheck: ThisIsMyDreamLineInputsHairStyleBoy,
        condition: (v: THairStyleBoyTIMDL) =>
          v === INPUT_VALUE_HAIR_STYLE_TIMDL_H02,
      },
    ],
  },
  {
    imgSrc: 'assets/images/timdl-canvas/H/avatar-H03.png',
    showWhen: [
      {
        inputToCheck: ThisIsMyDreamLineInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BLONDE,
      },
      {
        inputToCheck: ThisIsMyDreamLineInputsHairStyleBoy,
        condition: (v: THairStyleBoyTIMDL) =>
          v === INPUT_VALUE_HAIR_STYLE_TIMDL_H03,
      },
    ],
  },
  {
    imgSrc: 'assets/images/timdl-canvas/H/avatar-H04.png',
    showWhen: [
      {
        inputToCheck: ThisIsMyDreamLineInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BLONDE,
      },
      {
        inputToCheck: ThisIsMyDreamLineInputsHairStyleBoy,
        condition: (v: THairStyleBoyTIMDL) =>
          v === INPUT_VALUE_HAIR_STYLE_TIMDL_H04,
      },
    ],
  },
  {
    imgSrc: 'assets/images/timdl-canvas/H/avatar-H05.png',
    showWhen: [
      {
        inputToCheck: ThisIsMyDreamLineInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BLONDE,
      },
      {
        inputToCheck: ThisIsMyDreamLineInputsHairStyleBoy,
        condition: (v: THairStyleBoyTIMDL) =>
          v === INPUT_VALUE_HAIR_STYLE_TIMDL_H05,
      },
    ],
  },
  {
    imgSrc: 'assets/images/timdl-canvas/H/avatar-H06.png',
    showWhen: [
      {
        inputToCheck: ThisIsMyDreamLineInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BLONDE,
      },
      {
        inputToCheck: ThisIsMyDreamLineInputsHairStyleBoy,
        condition: (v: THairStyleBoyTIMDL) =>
          v === INPUT_VALUE_HAIR_STYLE_TIMDL_H06,
      },
    ],
  },
  {
    imgSrc: 'assets/images/timdl-canvas/H/avatar-H07.png',
    showWhen: [
      {
        inputToCheck: ThisIsMyDreamLineInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_RED,
      },
      {
        inputToCheck: ThisIsMyDreamLineInputsHairStyleBoy,
        condition: (v: THairStyleBoyTIMDL) =>
          v === INPUT_VALUE_HAIR_STYLE_TIMDL_H01,
      },
    ],
  },
  {
    imgSrc: 'assets/images/timdl-canvas/H/avatar-H08.png',
    showWhen: [
      {
        inputToCheck: ThisIsMyDreamLineInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_RED,
      },
      {
        inputToCheck: ThisIsMyDreamLineInputsHairStyleBoy,
        condition: (v: THairStyleBoyTIMDL) =>
          v === INPUT_VALUE_HAIR_STYLE_TIMDL_H02,
      },
    ],
  },
  {
    imgSrc: 'assets/images/timdl-canvas/H/avatar-H09.png',
    showWhen: [
      {
        inputToCheck: ThisIsMyDreamLineInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_RED,
      },
      {
        inputToCheck: ThisIsMyDreamLineInputsHairStyleBoy,
        condition: (v: THairStyleBoyTIMDL) =>
          v === INPUT_VALUE_HAIR_STYLE_TIMDL_H03,
      },
    ],
  },
  {
    imgSrc: 'assets/images/timdl-canvas/H/avatar-H10.png',
    showWhen: [
      {
        inputToCheck: ThisIsMyDreamLineInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_RED,
      },
      {
        inputToCheck: ThisIsMyDreamLineInputsHairStyleBoy,
        condition: (v: THairStyleBoyTIMDL) =>
          v === INPUT_VALUE_HAIR_STYLE_TIMDL_H04,
      },
    ],
  },
  {
    imgSrc: 'assets/images/timdl-canvas/H/avatar-H11.png',
    showWhen: [
      {
        inputToCheck: ThisIsMyDreamLineInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_RED,
      },
      {
        inputToCheck: ThisIsMyDreamLineInputsHairStyleBoy,
        condition: (v: THairStyleBoyTIMDL) =>
          v === INPUT_VALUE_HAIR_STYLE_TIMDL_H05,
      },
    ],
  },
  {
    imgSrc: 'assets/images/timdl-canvas/H/avatar-H12.png',
    showWhen: [
      {
        inputToCheck: ThisIsMyDreamLineInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_RED,
      },
      {
        inputToCheck: ThisIsMyDreamLineInputsHairStyleBoy,
        condition: (v: THairStyleBoyTIMDL) =>
          v === INPUT_VALUE_HAIR_STYLE_TIMDL_H06,
      },
    ],
  },
  {
    imgSrc: 'assets/images/timdl-canvas/H/avatar-H13.png',
    showWhen: [
      {
        inputToCheck: ThisIsMyDreamLineInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BROWN,
      },
      {
        inputToCheck: ThisIsMyDreamLineInputsHairStyleBoy,
        condition: (v: THairStyleBoyTIMDL) =>
          v === INPUT_VALUE_HAIR_STYLE_TIMDL_H01,
      },
    ],
  },
  {
    imgSrc: 'assets/images/timdl-canvas/H/avatar-H14.png',
    showWhen: [
      {
        inputToCheck: ThisIsMyDreamLineInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BROWN,
      },
      {
        inputToCheck: ThisIsMyDreamLineInputsHairStyleBoy,
        condition: (v: THairStyleBoyTIMDL) =>
          v === INPUT_VALUE_HAIR_STYLE_TIMDL_H02,
      },
    ],
  },
  {
    imgSrc: 'assets/images/timdl-canvas/H/avatar-H15.png',
    showWhen: [
      {
        inputToCheck: ThisIsMyDreamLineInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BROWN,
      },
      {
        inputToCheck: ThisIsMyDreamLineInputsHairStyleBoy,
        condition: (v: THairStyleBoyTIMDL) =>
          v === INPUT_VALUE_HAIR_STYLE_TIMDL_H03,
      },
    ],
  },
  {
    imgSrc: 'assets/images/timdl-canvas/H/avatar-H16.png',
    showWhen: [
      {
        inputToCheck: ThisIsMyDreamLineInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BROWN,
      },
      {
        inputToCheck: ThisIsMyDreamLineInputsHairStyleBoy,
        condition: (v: THairStyleBoyTIMDL) =>
          v === INPUT_VALUE_HAIR_STYLE_TIMDL_H04,
      },
    ],
  },
  {
    imgSrc: 'assets/images/timdl-canvas/H/avatar-H17.png',
    showWhen: [
      {
        inputToCheck: ThisIsMyDreamLineInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BROWN,
      },
      {
        inputToCheck: ThisIsMyDreamLineInputsHairStyleBoy,
        condition: (v: THairStyleBoyTIMDL) =>
          v === INPUT_VALUE_HAIR_STYLE_TIMDL_H05,
      },
    ],
  },
  {
    imgSrc: 'assets/images/timdl-canvas/H/avatar-H18.png',
    showWhen: [
      {
        inputToCheck: ThisIsMyDreamLineInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BROWN,
      },
      {
        inputToCheck: ThisIsMyDreamLineInputsHairStyleBoy,
        condition: (v: THairStyleBoyTIMDL) =>
          v === INPUT_VALUE_HAIR_STYLE_TIMDL_H06,
      },
    ],
  },
  {
    imgSrc: 'assets/images/timdl-canvas/H/avatar-H19.png',
    showWhen: [
      {
        inputToCheck: ThisIsMyDreamLineInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BLACK,
      },
      {
        inputToCheck: ThisIsMyDreamLineInputsHairStyleBoy,
        condition: (v: THairStyleBoyTIMDL) =>
          v === INPUT_VALUE_HAIR_STYLE_TIMDL_H01,
      },
    ],
  },
  {
    imgSrc: 'assets/images/timdl-canvas/H/avatar-H20.png',
    showWhen: [
      {
        inputToCheck: ThisIsMyDreamLineInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BLACK,
      },
      {
        inputToCheck: ThisIsMyDreamLineInputsHairStyleBoy,
        condition: (v: THairStyleBoyTIMDL) =>
          v === INPUT_VALUE_HAIR_STYLE_TIMDL_H02,
      },
    ],
  },
  {
    imgSrc: 'assets/images/timdl-canvas/H/avatar-H21.png',
    showWhen: [
      {
        inputToCheck: ThisIsMyDreamLineInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BLACK,
      },
      {
        inputToCheck: ThisIsMyDreamLineInputsHairStyleBoy,
        condition: (v: THairStyleBoyTIMDL) =>
          v === INPUT_VALUE_HAIR_STYLE_TIMDL_H03,
      },
    ],
  },
  {
    imgSrc: 'assets/images/timdl-canvas/H/avatar-H22.png',
    showWhen: [
      {
        inputToCheck: ThisIsMyDreamLineInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BLACK,
      },
      {
        inputToCheck: ThisIsMyDreamLineInputsHairStyleBoy,
        condition: (v: THairStyleBoyTIMDL) =>
          v === INPUT_VALUE_HAIR_STYLE_TIMDL_H04,
      },
    ],
  },
  {
    imgSrc: 'assets/images/timdl-canvas/H/avatar-H23.png',
    showWhen: [
      {
        inputToCheck: ThisIsMyDreamLineInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BLACK,
      },
      {
        inputToCheck: ThisIsMyDreamLineInputsHairStyleBoy,
        condition: (v: THairStyleBoyTIMDL) =>
          v === INPUT_VALUE_HAIR_STYLE_TIMDL_H05,
      },
    ],
  },
  {
    imgSrc: 'assets/images/timdl-canvas/H/avatar-H24.png',
    showWhen: [
      {
        inputToCheck: ThisIsMyDreamLineInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BLACK,
      },
      {
        inputToCheck: ThisIsMyDreamLineInputsHairStyleBoy,
        condition: (v: THairStyleBoyTIMDL) =>
          v === INPUT_VALUE_HAIR_STYLE_TIMDL_H06,
      },
    ],
  },
];

const ThisIsMyDreamLineItemsHairGirl: ICanvasInputItem[] = [
  {
    imgSrc: 'assets/images/timdl-canvas/H/avatar-H25.png',
    showWhen: [
      {
        inputToCheck: ThisIsMyDreamLineInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BLONDE,
      },
      {
        inputToCheck: ThisIsMyDreamLineInputsHairStyleGirl,
        condition: (v: THairStyleGirlTIMDL) =>
          v === INPUT_VALUE_HAIR_STYLE_TIMDL_H02,
      },
    ],
  },
  {
    imgSrc: 'assets/images/timdl-canvas/H/avatar-H26.png',
    showWhen: [
      {
        inputToCheck: ThisIsMyDreamLineInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BLONDE,
      },
      {
        inputToCheck: ThisIsMyDreamLineInputsHairStyleGirl,
        condition: (v: THairStyleGirlTIMDL) =>
          v === INPUT_VALUE_HAIR_STYLE_TIMDL_H07,
      },
    ],
  },
  {
    imgSrc: 'assets/images/timdl-canvas/H/avatar-H27.png',
    showWhen: [
      {
        inputToCheck: ThisIsMyDreamLineInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BLONDE,
      },
      {
        inputToCheck: ThisIsMyDreamLineInputsHairStyleGirl,
        condition: (v: THairStyleGirlTIMDL) =>
          v === INPUT_VALUE_HAIR_STYLE_TIMDL_H08,
      },
    ],
  },
  {
    imgSrc: 'assets/images/timdl-canvas/H/avatar-H28.png',
    showWhen: [
      {
        inputToCheck: ThisIsMyDreamLineInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BLONDE,
      },
      {
        inputToCheck: ThisIsMyDreamLineInputsHairStyleGirl,
        condition: (v: THairStyleGirlTIMDL) =>
          v === INPUT_VALUE_HAIR_STYLE_TIMDL_H04,
      },
    ],
  },
  {
    imgSrc: 'assets/images/timdl-canvas/H/avatar-H29.png',
    showWhen: [
      {
        inputToCheck: ThisIsMyDreamLineInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BLONDE,
      },
      {
        inputToCheck: ThisIsMyDreamLineInputsHairStyleGirl,
        condition: (v: THairStyleGirlTIMDL) =>
          v === INPUT_VALUE_HAIR_STYLE_TIMDL_H09,
      },
    ],
  },
  {
    imgSrc: 'assets/images/timdl-canvas/H/avatar-H30.png',
    showWhen: [
      {
        inputToCheck: ThisIsMyDreamLineInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BLONDE,
      },
      {
        inputToCheck: ThisIsMyDreamLineInputsHairStyleGirl,
        condition: (v: THairStyleGirlTIMDL) =>
          v === INPUT_VALUE_HAIR_STYLE_TIMDL_H06,
      },
    ],
  },
  {
    imgSrc: 'assets/images/timdl-canvas/H/avatar-H31.png',
    showWhen: [
      {
        inputToCheck: ThisIsMyDreamLineInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_RED,
      },
      {
        inputToCheck: ThisIsMyDreamLineInputsHairStyleGirl,
        condition: (v: THairStyleGirlTIMDL) =>
          v === INPUT_VALUE_HAIR_STYLE_TIMDL_H02,
      },
    ],
  },
  {
    imgSrc: 'assets/images/timdl-canvas/H/avatar-H32.png',
    showWhen: [
      {
        inputToCheck: ThisIsMyDreamLineInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_RED,
      },
      {
        inputToCheck: ThisIsMyDreamLineInputsHairStyleGirl,
        condition: (v: THairStyleGirlTIMDL) =>
          v === INPUT_VALUE_HAIR_STYLE_TIMDL_H07,
      },
    ],
  },
  {
    imgSrc: 'assets/images/timdl-canvas/H/avatar-H33.png',
    showWhen: [
      {
        inputToCheck: ThisIsMyDreamLineInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_RED,
      },
      {
        inputToCheck: ThisIsMyDreamLineInputsHairStyleGirl,
        condition: (v: THairStyleGirlTIMDL) =>
          v === INPUT_VALUE_HAIR_STYLE_TIMDL_H08,
      },
    ],
  },
  {
    imgSrc: 'assets/images/timdl-canvas/H/avatar-H34.png',
    showWhen: [
      {
        inputToCheck: ThisIsMyDreamLineInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_RED,
      },
      {
        inputToCheck: ThisIsMyDreamLineInputsHairStyleGirl,
        condition: (v: THairStyleGirlTIMDL) =>
          v === INPUT_VALUE_HAIR_STYLE_TIMDL_H04,
      },
    ],
  },
  {
    imgSrc: 'assets/images/timdl-canvas/H/avatar-H35.png',
    showWhen: [
      {
        inputToCheck: ThisIsMyDreamLineInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_RED,
      },
      {
        inputToCheck: ThisIsMyDreamLineInputsHairStyleGirl,
        condition: (v: THairStyleGirlTIMDL) =>
          v === INPUT_VALUE_HAIR_STYLE_TIMDL_H09,
      },
    ],
  },
  {
    imgSrc: 'assets/images/timdl-canvas/H/avatar-H36.png',
    showWhen: [
      {
        inputToCheck: ThisIsMyDreamLineInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_RED,
      },
      {
        inputToCheck: ThisIsMyDreamLineInputsHairStyleGirl,
        condition: (v: THairStyleGirlTIMDL) =>
          v === INPUT_VALUE_HAIR_STYLE_TIMDL_H06,
      },
    ],
  },
  {
    imgSrc: 'assets/images/timdl-canvas/H/avatar-H37.png',
    showWhen: [
      {
        inputToCheck: ThisIsMyDreamLineInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BROWN,
      },
      {
        inputToCheck: ThisIsMyDreamLineInputsHairStyleGirl,
        condition: (v: THairStyleGirlTIMDL) =>
          v === INPUT_VALUE_HAIR_STYLE_TIMDL_H02,
      },
    ],
  },
  {
    imgSrc: 'assets/images/timdl-canvas/H/avatar-H38.png',
    showWhen: [
      {
        inputToCheck: ThisIsMyDreamLineInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BROWN,
      },
      {
        inputToCheck: ThisIsMyDreamLineInputsHairStyleGirl,
        condition: (v: THairStyleGirlTIMDL) =>
          v === INPUT_VALUE_HAIR_STYLE_TIMDL_H07,
      },
    ],
  },
  {
    imgSrc: 'assets/images/timdl-canvas/H/avatar-H39.png',
    showWhen: [
      {
        inputToCheck: ThisIsMyDreamLineInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BROWN,
      },
      {
        inputToCheck: ThisIsMyDreamLineInputsHairStyleGirl,
        condition: (v: THairStyleGirlTIMDL) =>
          v === INPUT_VALUE_HAIR_STYLE_TIMDL_H08,
      },
    ],
  },
  {
    imgSrc: 'assets/images/timdl-canvas/H/avatar-H40.png',
    showWhen: [
      {
        inputToCheck: ThisIsMyDreamLineInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BROWN,
      },
      {
        inputToCheck: ThisIsMyDreamLineInputsHairStyleGirl,
        condition: (v: THairStyleGirlTIMDL) =>
          v === INPUT_VALUE_HAIR_STYLE_TIMDL_H04,
      },
    ],
  },
  {
    imgSrc: 'assets/images/timdl-canvas/H/avatar-H41.png',
    showWhen: [
      {
        inputToCheck: ThisIsMyDreamLineInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BROWN,
      },
      {
        inputToCheck: ThisIsMyDreamLineInputsHairStyleGirl,
        condition: (v: THairStyleGirlTIMDL) =>
          v === INPUT_VALUE_HAIR_STYLE_TIMDL_H09,
      },
    ],
  },
  {
    imgSrc: 'assets/images/timdl-canvas/H/avatar-H42.png',
    showWhen: [
      {
        inputToCheck: ThisIsMyDreamLineInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BROWN,
      },
      {
        inputToCheck: ThisIsMyDreamLineInputsHairStyleGirl,
        condition: (v: THairStyleGirlTIMDL) =>
          v === INPUT_VALUE_HAIR_STYLE_TIMDL_H06,
      },
    ],
  },
  {
    imgSrc: 'assets/images/timdl-canvas/H/avatar-H43.png',
    showWhen: [
      {
        inputToCheck: ThisIsMyDreamLineInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BLACK,
      },
      {
        inputToCheck: ThisIsMyDreamLineInputsHairStyleGirl,
        condition: (v: THairStyleGirlTIMDL) =>
          v === INPUT_VALUE_HAIR_STYLE_TIMDL_H02,
      },
    ],
  },
  {
    imgSrc: 'assets/images/timdl-canvas/H/avatar-H44.png',
    showWhen: [
      {
        inputToCheck: ThisIsMyDreamLineInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BLACK,
      },
      {
        inputToCheck: ThisIsMyDreamLineInputsHairStyleGirl,
        condition: (v: THairStyleGirlTIMDL) =>
          v === INPUT_VALUE_HAIR_STYLE_TIMDL_H07,
      },
    ],
  },
  {
    imgSrc: 'assets/images/timdl-canvas/H/avatar-H45.png',
    showWhen: [
      {
        inputToCheck: ThisIsMyDreamLineInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BLACK,
      },
      {
        inputToCheck: ThisIsMyDreamLineInputsHairStyleGirl,
        condition: (v: THairStyleGirlTIMDL) =>
          v === INPUT_VALUE_HAIR_STYLE_TIMDL_H08,
      },
    ],
  },
  {
    imgSrc: 'assets/images/timdl-canvas/H/avatar-H46.png',
    showWhen: [
      {
        inputToCheck: ThisIsMyDreamLineInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BLACK,
      },
      {
        inputToCheck: ThisIsMyDreamLineInputsHairStyleGirl,
        condition: (v: THairStyleGirlTIMDL) =>
          v === INPUT_VALUE_HAIR_STYLE_TIMDL_H04,
      },
    ],
  },
  {
    imgSrc: 'assets/images/timdl-canvas/H/avatar-H47.png',
    showWhen: [
      {
        inputToCheck: ThisIsMyDreamLineInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BLACK,
      },
      {
        inputToCheck: ThisIsMyDreamLineInputsHairStyleGirl,
        condition: (v: THairStyleGirlTIMDL) =>
          v === INPUT_VALUE_HAIR_STYLE_TIMDL_H09,
      },
    ],
  },
  {
    imgSrc: 'assets/images/timdl-canvas/H/avatar-H48.png',
    showWhen: [
      {
        inputToCheck: ThisIsMyDreamLineInputsHairColor,
        condition: (v: THairColor) => v === INPUT_VALUE_HAIR_COLOR_BLACK,
      },
      {
        inputToCheck: ThisIsMyDreamLineInputsHairStyleGirl,
        condition: (v: THairStyleGirlTIMDL) =>
          v === INPUT_VALUE_HAIR_STYLE_TIMDL_H06,
      },
    ],
  },
];

const ThisIsMyDreamLineBabyInputsCanvasCommon = {
  width: 312,
  height: 459,
  crop: {
    top: 10,
    right: 10,
    bottom: 10,
    left: 10,
  },
  cropLtMd: {
    top: 15,
    left: 30,
    bottom: 220,
  },
  name: INPUT_NAME_RESERVED_CANVAS1,
} as const;

export const ThisIsMyDreamLineInputsCanvasBoy = getCanvasInputData({
  ...ThisIsMyDreamLineBabyInputsCanvasCommon,
  name: INPUT_NAME_RESERVED_CANVAS1 as typeof INPUT_NAME_RESERVED_CANVAS1,
  label: '子どもにそっくりの主人公を作りましょう！',
  inputs: ThisIsMyDreamLineInputsCanvasBoyInputs,
  items: [
    ...ThisIsMyDreamLineItemsSkin,
    ...ThisIsMyDreamLineItemsHairBoy,
    {
      imgSrc: 'assets/images/timdl-canvas/G/avatar-G01.png',
      showWhen: [
        {
          inputToCheck: ThisIsMyDreamLineInputsGlasses,
          condition: (v: boolean) => v,
        },
      ],
    },
  ],
  value: bookInputsToNameValueMap(ThisIsMyDreamLineInputsCanvasBoyInputs),
});

export const ThisIsMyDreamLineInputsCanvasGirl = getCanvasInputData({
  ...ThisIsMyDreamLineBabyInputsCanvasCommon,
  name: INPUT_NAME_RESERVED_CANVAS1 as typeof INPUT_NAME_RESERVED_CANVAS1,
  label: '子どもにそっくりの主人公を作りましょう！',
  inputs: ThisIsMyDreamLineInputsCanvasGirlInputs,
  items: [
    ...ThisIsMyDreamLineItemsSkin,
    ...ThisIsMyDreamLineItemsHairGirl,
    {
      imgSrc: 'assets/images/timdl-canvas/G/avatar-G01.png',
      showWhen: [
        {
          inputToCheck: ThisIsMyDreamLineInputsGlasses,
          condition: (v: boolean) => v,
        },
      ],
    },
  ],
  value: bookInputsToNameValueMap(ThisIsMyDreamLineInputsCanvasGirlInputs),
});

export const ThisIsMyDreamLineInputsChildLikes = getMultiselectInputData({
  label: '子どもの好きなものを3つ選んでください',
  options: childLikesTIMDLArr.map((value) =>
    getMultiselectInputOptionData({
      imgSrc: `assets/images/timdl-childs-preferences/icons/icon_${value}.png`,
      label: CHILD_LIKES_TO_NAME_MAP[value],
      value,
    }),
  ),
  min: 3,
  max: 3,
  styleColumnsConfig: {
    'lt-md': 1,
    'gt-sm': 2,
  },
  name: INPUT_NAME_CHILD_LIKES,
  placeholder: '1～6歳',
});

// * mutations
bookInputShowWhen(
  ThisIsMyDreamLineInputsCanvasGirl,
  ThisIsMyDreamLineInputsGender,
  (gender: TGender) => gender === INPUT_VALUE_GENDER_GIRL,
);

bookInputShowWhen(
  ThisIsMyDreamLineInputsCanvasBoy,
  ThisIsMyDreamLineInputsGender,
  (gender: TGender) => gender === INPUT_VALUE_GENDER_BOY,
);

const prices = {
  [INPUT_VALUE_COVER_TYPE_SOFT]: getPriceData(
    BOOK_PRICE_TOKYO_METRO_THIS_IS_MY_DREAM_LINE,
  ),
  [INPUT_VALUE_COVER_TYPE_HARD]: getPriceData(
    BOOK_PRICE_TOKYO_METRO_THIS_IS_MY_DREAM_LINE_HARD_COVER,
  ),
} as const;

const coverSoft = getCoverSoft({
  price: prices[INPUT_VALUE_COVER_TYPE_SOFT],
  carousel: [
    'assets/images/covers/letsmakemetro/SC01.jpg',
    'assets/images/covers/letsmakemetro/SC02.jpg',
    'assets/images/covers/letsmakemetro/SC03.jpg',
  ],
});
const coverHard = getCoverHard({
  price: prices[INPUT_VALUE_COVER_TYPE_HARD],
  carousel: [
    'assets/images/covers/letsmakemetro/HC01.jpg',
    'assets/images/covers/letsmakemetro/HC02.jpg',
    'assets/images/covers/letsmakemetro/HC03.jpg',
  ],
});

const reviewMock: IReview = {
  photoImgSrc: 'https://placehold.co/349',
  userPhotoImgSrc: 'https://placehold.co/100',
  userName: '',
  text: [
    '息子のクリスマスプレゼントで購入🎄🎁',
    '好きなものだらけの路線ができて、息子が大興奮💐',
    '絵も可愛くて息子も母もニコニコ︎︎︎︎︎😀出産祝いにもいいなって思った🕊',
  ],
};

const ThisIsMyDreamLine: IBookPreview = {
  type: 'book',
  caption: '自分だけの夢の電車を作ろう！',
  summary:
    '好きなものを全部つめこんで、世界に一つだけの地下鉄路線をつくろう！　主人公は、他でもないあなたのお子さま。',
  alias: BOOK_ALIAS_THIS_IS_MY_DREAM_LINE,
  prices: [
    [INPUT_VALUE_COVER_TYPE_SOFT, prices[INPUT_VALUE_COVER_TYPE_SOFT]],
    [INPUT_VALUE_COVER_TYPE_HARD, prices[INPUT_VALUE_COVER_TYPE_HARD]],
  ],
  photos: [
    'assets/images/TM-BK2-carousel01.jpg',
    'assets/images/TM-BK2-carousel02.jpg',
    'assets/images/TM-BK2-carousel03.jpg',
    'assets/images/TM-BK2-carousel04.jpg',
    'assets/images/TM-BK2-carousel05.jpg',
  ],
  menuPhoto: 'assets/images/lmm-sample.jpg',
  previewPhoto: 'assets/images/lmm-sample.jpg',
  // TODO
  properties: {
    purpose: [PURPOSE_ADVENTURE, PURPOSE_BIRTH_GIFT],
    age: {
      start: 0,
      end: 3,
    },
  },
  notice: {
    caption: 'ぼくの・わたしの夢の電車',
    description:
      '今のあなたが好きなものをつなげて、自分だけの電車を作ろう！　出発進行！　この電車でどこへ行こう？',
    points: [
      {
        imgSrc: 'assets/images/welcome-notice-point-1.png',
        caption: '5〜10歳におすすめ',
      },
      {
        imgSrc: 'assets/images/welcome-notice-point-2.png',
        caption: '歴史や地下鉄を学ぶ',
      },
    ],
  },
  points: [
    {
      caption: 'どんなカスタマイズができるの？',
      description:
        '・子どもの名前を入れる<br>・子どものイラストを選ぶ<br>・好きなものに合わせてストーリーが変化する<br>・メッセージを書き込む<br>・写真を入れる',
    },
    {
      caption: '絵本のストーリーは？',
      description:
        '主人公が大好きなものを乗せて走る、世界に一つだけの地下鉄路線。さぁ、どんな「ゆめの路線」になるかな？',
    },
    {
      caption: 'ページ数や絵本の大きさは？',
      description:
        '全ての絵本は１冊ずつ、ご注文を受けてからオーダーメイドで印刷・製本されます。マットで高級感のある、環境に配慮した用紙を使用しています。<br><br><b>・全34 ページ<br>・縦21cm x 横29.7cm（本文部分）のA4ヨコサイズ<br>・日本国内で製造</b>',
    },
  ],
  inputs: [
    ThisIsMyDreamLineInputsKidsName,
    ThisIsMyDreamLineInputsKunChan,
    ThisIsMyDreamLineInputsGender,
    ThisIsMyDreamLineInputsCanvasGirl,
    ThisIsMyDreamLineInputsCanvasBoy,
    ThisIsMyDreamLineInputsChildLikes,
  ],
  banner: {
    imgSrc: 'assets/images/bk3-banner-desktop-JP.jpg',
    imgSrcLtMd: 'assets/images/bk3-banner-mobile-JP.jpg',
    text: 'まいにちが　だいぼうけん。　ここにある　まほうを　みつけよう。',
    textColor: EBannerTextColor.dark,
  },
  description: [
    {
      imgSrc: 'assets/images/TM-BK2-point01.jpg',
      text: [
        {
          type: EDescriptionTextItemType.caption,
          text: /* html */ `<span style="font-family: ZenMaruGothic">好きなものだらけの地下鉄！</span>`,
        },
        {
          type: EDescriptionTextItemType.regular,
          text: '恐竜好き、どうぶつ好き、プリンセス好き……。お子さまの「好き」が主人公の地下鉄路線に反映される。',
        },
      ],
    },
    {
      imgSrc: 'assets/images/TM-BK2-point02.jpg',
      text: [
        {
          type: EDescriptionTextItemType.caption,
          text: /* html */ `<span style="font-family: ZenMaruGothic">好きなことを追体験</span>`,
        },
        {
          type: EDescriptionTextItemType.regular,

          text: `「ゆめの路線を作る」と言っても、詰め込みたいものはたくさん……！　お子さまが興味のある分野に合わせて、物語を追体験しましょう。`,
        },
      ],
    },
    {
      imgSrc: 'assets/images/TM-BK2-point03.jpg',
      text: [
        {
          type: EDescriptionTextItemType.caption,
          text: /* html */ `<span style="font-family: ZenMaruGothic">子どもの背中を押すメッセージを</span>`,
        },
        {
          type: EDescriptionTextItemType.regular,

          text: `好きなものを集めて走らせる、世界に一つだけの地下鉄路線……。夢は、自分の手でかたちにできる。そんなメッセージを、お子さまに残しましょう！`,
        },
      ],
    },
    {
      imgSrc: 'assets/images/TM-BK2-point04.gif',
      text: [
        {
          type: EDescriptionTextItemType.caption,
          text: /* html */ `<span style="font-family: ZenMaruGothic">東京メトロの世界を知ろう！</span>`,
        },
        {
          type: EDescriptionTextItemType.regular,

          text: `普段何気なく使っている地下鉄……。絵本を通して、お子さまだけの路線づくりを楽しみましょう！　読み終わると、普段通り過ぎていく駅やトンネルが少し特別に感じるはずです。`,
        },
      ],
    },
  ],
  review: {
    text: [
      '電車がとにかく好きな甥っ子へのプレゼントに選びました。すごく喜んでくれたので良かったです。',
    ],
  },
  reviews: [
    reviewMock,
    reviewMock,
    reviewMock,
    reviewMock,
    reviewMock,
    reviewMock,
  ],
  options: {
    [INPUT_VALUE_COVER_TYPE_HARD]: coverHard,
    [INPUT_VALUE_COVER_TYPE_SOFT]: coverSoft,
  },
  option: INPUT_VALUE_COVER_TYPE_SOFT,
  // TODO
  attributes: [
    {
      id: 'category',
      value: 'books',
    },
  ],
  popularity: 10,
  createdAt: new Date('2026-07-27'),
};

export default ThisIsMyDreamLine;
